<script setup>
import LoginForm from "@/components/parent/LoginForm.vue";
</script>

<template>
  <LoginForm />
</template>
